module.exports = __webpack_public_path__ + "628ce9b4d5d6bc7d83054f73bf24c082.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/fonts/freeplay.ttf
// module id = ./src/styles/icons/fonts/freeplay.ttf
// module chunks = 0